import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import UserInitials from 'components/models/user/user-initials';
import classNames from 'classnames';
import { connect } from 'react-redux';

function UserBadge({ user: passedUser, userId, users, className, badgeForCurrentUser, team, teams, ...passedProps }) {
  if (_.isEmpty(passedUser) && !userId) return null;
  
  const user = passedUser || _.find(users, { id: userId }) || {};
  const userTeam = team || (_.isObject(user.team) ? user.team : _.find(teams, { id: user.team }));
  const teamColor = (userTeam || {}).color;
  const styles = teamColor ? { backgroundColor: teamColor, borderColor: teamColor } : {};

  return (
    <UserInitials
      {...passedProps}
      className={classNames('user-badge', { 'badge-for-current-user': badgeForCurrentUser }, className)}
      style={styles}
      user={user}
    />
  );
}

UserBadge.propTypes = {
  user: PropTypes.object,
  userId: PropTypes.number,
  className: PropTypes.string,
  badgeForCurrentUser: PropTypes.bool,
  team: PropTypes.object,
  users: PropTypes.array.isRequired,
  teams: PropTypes.array
};

export default connect((state) => ({
  users: state.pageData.selectUsers,
  teams: state.pageData.teams
}))(UserBadge);
